<template lang="pug">
	.networks(ref="networks" v-if="Version.SelectedVersion && Creative.SelectedCreative && (Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'banner' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'editable-playable')" v-bar :style="{height: getHeight() + 'px'}" v-pseudo-modal-name="'networks'")
		.networks-content(v-if="Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'editable-playable'" @scroll.passive="onScroll")
			.dropdown-item(v-for="release in availableReleases" v-if="release.type === 'playable' && !release['group_codename']" :class="{'selected': isReleaseSelected(release), 'group': release.isGroup}" @click.stop="selectNetwork(release, $event)")
				.item-title
					span {{release.title}}
					.group-expand-icon
						.fa.fa-angle-double-left
					.multiple-select-checkmark-wrapper(v-if="(scope === 'download' || scope === 'upload')")
						.checkbox-background
							.fa.fa-check
					.group-selected-releases-count {{getSelectedReleasesInGroup(release).length}} builds selected
					.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
					.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
				.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${getNetworkIcon(release)})`, width: release.options['iconWidth']}")
				.item-description.text-muted {{release.description}}
		.networks-content(v-if="Creative.SelectedCreative.type === 'banner'")
			.dropdown-item(v-for="release in availableReleases" v-if="release.type === 'banner'" @click="selectNetwork(release, $event)" )
				.item-title {{release.title}}
					.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
					.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
				.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${getNetworkIcon(release)})`, width: release.options['iconWidth']}")
				.item-description.text-muted {{release.description}}
					.group-items(v-if="release.isGroup")
		.networks-inner(v-if="selectedGroup" v-bar :style="{top: selectedGroupPosition.top, height: getInnerHeight() + 'px'}")
			.networks-content
				.dropdown-item(v-for="release in availableReleases" v-if="release.type === 'playable' && release['group_codename'] === selectedGroup['codename']" :class="{'selected': isReleaseSelected(release), 'outdated': release.options.outdated}" @click.stop="selectNetwork(release, $event)")
					.item-title
						span {{release.title}}
						.group-expand-icon
							.fa.fa-angle-double-left
						.multiple-select-checkmark-wrapper(v-if="(scope === 'download' || scope === 'upload')")
							.checkbox-background
								.fa.fa-check(v-show="isReleaseSelected(release)")
						.icon.fa.fa-spinner.fa-spin(v-if="isInProcess(release.codename)")
						.error(v-if="getProcessError(release.codename)") {{getProcessError(release.codename)}}
					.item-icon(:style="{backgroundImage: `url(/Images/Icons/Networks/${getNetworkIcon(release)})`, width: release.options['iconWidth']}")
					.item-description.text-muted {{release.description}}
</template>

<script>

	import Screen 				from './../../mixins/screen'

	import { Metadata } 		from './../../services/Metadata'
	import { Publisher } 		from '../../services/Publisher'
	import { Creative } 			from '../../services/Creative'
	import { Version } 			from '../../services/Version'
	import { Asset } 			from '../../services/Asset'
	import { Monitoring } 		from '../../services/Monitoring'
	import { User } 			from "../../services/User"

	export default {
		name: "NetworkList",
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Publisher Changed",
				"Selected Publisher Data Changed",
				"Selected Version Switched",
				"Metadata Loaded",
				"Active Processes Changed:release-build",
				"Creative Fully Loaded"
			],
			"Pseudo Modal Process Hide": function(names) {

				if (!_.includes(names, 'networks') && this.selectedGroup) {

					this.unsetSelectedGroup();

				}

			}
		},
		props: ['callback', 'scope', 'multipleAllowed', 'network'],
		data() {

			this.Publisher = Publisher;
			this.Creative = Creative;
			this.Version = Version;
			this.Asset = Asset;
			this.Monitoring = Monitoring;

			this.releases = [];
			this.availableReleases = [];
			this.selectedGroup = null;

			return {
				showed: true,
				releaseType: '',
				selectedGroupPosition: {
					top: 0,
					screenTop: 0 // положение верхнего края меню второго уровня относительно окна браузера
				}
			};

		},
		methods: {
			collectData() {

				if (!Creative.SelectedCreative || Creative.SelectedCreative.type === 'storyboard') return;

				let releases = _.values(Metadata.Releases);

				this.availableReleases = releases.filter(release => this.isReleaseAvailable(release));

				_.each(Metadata.ReleaseGroups, releaseGroup => {

					//console.log('releaseGroup', releaseGroup, !!_.find(this.availableReleases, release => release['group_codename'] === releaseGroup.codename));

					// Если есть доступные релизы относящиеся к этой группе - добавляем группу в список рендеринга релизов
					if (_.find(this.availableReleases, release => release['group_codename'] === releaseGroup.codename)) this.availableReleases.push({..._.pick(releaseGroup, ["id", "codename", "title", "description", "type", "priority", "options"]), isGroup: true})

				});

				//console.log('this.availableReleases', this.availableReleases);

				// Уберем релизы, которые должны находиться в группах
				// this.availableReleases = _.filter(this.availableReleases, release => !release["group_codename"]);

				this.availableReleases = _.orderBy(this.availableReleases, 'priority');

				//console.log('collectData');

				//if (this.scope === 'upload' && !this.multipleAllowed) this.selectNetwork(this.availableReleases[0]);

			},
			selectNetwork(release, e = null) {

				console.log('selectNetwork', release);

				if (release.isGroup) {

					if (this.selectedGroup?.codename === release.codename) this.unsetSelectedGroup();
					else this.setSelectedGroup(release, e);

				} else if (this.multipleAllowed) {

					if (this.scope === 'download') {

						let selectedReleases = User.currentUser.options.features.multipleDownloadNetworks || {};
						if (selectedReleases[release.codename]) delete selectedReleases[release.codename];
						else selectedReleases[release.codename] = true;
						User.currentUser.options.features.multipleDownloadNetworks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleDownloadNetworks', selectedReleases);

						Broadcast.call('Multiple Download Networks Changed', [Object.keys(selectedReleases || {}).length]);

					} else if (this.scope === 'upload' && this.network === 'mraid') {

						let selectedReleases = User.currentUser.options.features.multipleUploadMraidioNetworks || {};
						if (selectedReleases[release.codename]) delete selectedReleases[release.codename];
						else selectedReleases[release.codename] = true;
						User.currentUser.options.features.multipleUploadMraidioNetworks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleUploadMraidioNetworks', selectedReleases);

						Broadcast.call('Multiple Upload Mraidio Networks Changed', [Object.keys(selectedReleases || {}).length]);

					} else if (this.scope === 'upload' && this.network === 'amazons3') {

						let selectedReleases = User.currentUser.options.features.multipleUploadAmazonS3Networks || {};
						if (selectedReleases[release.codename]) delete selectedReleases[release.codename];
						else selectedReleases[release.codename] = true;
						User.currentUser.options.features.multipleUploadAmazonS3Networks = selectedReleases;
						User.toggleFeature(User.currentUser.id, 'multipleUploadAmazonS3Networks', selectedReleases);

						Broadcast.call('Multiple Upload Amazon S3 Networks Changed', [Object.keys(selectedReleases || {}).length]);

					}

					if (this.selectedGroup && release["group_codename"] !== this.selectedGroup["codename"]) this.unsetSelectedGroup();

					this.$forceUpdate();

				} else {

					this.callback(release.codename);

					if (this.selectedGroup && release["group_codename"] !== this.selectedGroup["codename"]) this.unsetSelectedGroup();

				}

			},
			setSelectedGroup(selectedGroup, e = null) {

				this.selectedGroup = selectedGroup;

				let rect = e.target.closest('.dropdown-item').getBoundingClientRect(),
					parentRect = this.$refs['networks'].getBoundingClientRect();

				this.selectedGroupPosition.top = rect.top - parentRect.top + 'px';
				this.selectedGroupPosition.screenTop = rect.top;

				this.update();

			},
			unsetSelectedGroup() {

				this.selectedGroup = null;

				this.update();

			},
			onScroll() {

				if (this.selectedGroup) this.unsetSelectedGroup();

			},
			isReleaseAvailable(release) {

				if (!release['enabled']) return false;

				if (!release.options['scope'].includes(this.scope)) return false;

				if (release['publisher_id'] && release['publisher_id'] !== Publisher.SelectedPublisher?.id) return false;

				if (this.multipleAllowed && this.scope === 'download' && release.codename === 'sky-kids') return false;

				if (release.codename in (Publisher.SelectedPublisher?.options?.['Releases'] || {})) return Publisher.SelectedPublisher.options['Releases'][release.codename];

				if (release.type === 'playable' && Creative.SelectedCreative?.type !== 'playable' && Creative.SelectedCreative?.type !== 'end-card' && Creative.SelectedCreative?.type !== 'editable-playable') return false;
				if (release.type === 'banner' && Creative.SelectedCreative?.type !== 'banner') return false;

				return release.options["enabledByDefault"];

			},
			isReleaseSelected(release) {

				if (!this.multipleAllowed) return false;

				if (!User.currentUser?.options?.features) return false;

				if (release.isGroup) {

					return this.getSelectedReleasesInGroup(release).length > 0;

				} else if (this.scope === 'download') {

					return User.currentUser.options.features.multipleDownloadNetworks && User.currentUser.options.features.multipleDownloadNetworks[release.codename];

				} else if (this.scope === 'upload' && this.network === 'mraid') {

					return User.currentUser.options.features.multipleUploadMraidioNetworks && User.currentUser.options.features.multipleUploadMraidioNetworks[release.codename];

				} else if (this.scope === 'upload' && this.network === 'amazons3') {

					return User.currentUser.options.features.multipleUploadAmazonS3Networks && User.currentUser.options.features.multipleUploadAmazonS3Networks[release.codename];

				}

				return false;

			},
			getSelectedReleasesInGroup(releaseGroup) {

				if (!releaseGroup.isGroup) return [];

				return _.filter(this.availableReleases, release => release["group_codename"] === releaseGroup.codename && this.isReleaseSelected(release))

			},
			isInProcess(releaseType) {

				return this.scope === 'download' && Monitoring.activeProcesses['release-build'][`${Version.SelectedVersion.id}-${releaseType}`]

			},
			getProcessError(releaseType) {

				if (this.scope === 'download' && Monitoring.activeProcessesErrors['release-build'][`${Version.SelectedVersion.id}-${releaseType}`]) {

					let process = Monitoring.activeProcessesErrors['release-build'][`${Version.SelectedVersion.id}-${releaseType}`];

					if (process.error?.type === 'asset-compress') return `Asset failed: ${process.error.assetCodename}`;
					else return `Unknown error`;

				} else {

					return false;

				}

			},
			getHeight(isInner = false) {

				let releases = [];

				if (isInner) {

					if (!this.selectedGroup) return 0;

					releases = _.filter(this.availableReleases, release => release.type === 'playable' && release['group_codename'] === this.selectedGroup['codename']);

				} else {

					if (Creative.SelectedCreative.type === 'playable' || Creative.SelectedCreative.type === 'end-card' || Creative.SelectedCreative.type === 'editable-playable') releases = _.filter(this.availableReleases, release => release.type === 'playable' && !release['group_codename']);
					else if (Creative.SelectedCreative.type === 'banner') releases = _.filter(this.availableReleases, release => release.type === 'banner');

				}

				let maxHeightByNetworksCount = releases.length * 56;

				let height = 0;

				if (this.scope === 'upload') {

					let maxHeightByVH = window.innerHeight / 2 - 100;

					height = Math.min(maxHeightByVH, maxHeightByNetworksCount);

				} else {

					let heightOffset =
						170 // 170 может занимать информация о непрошедших тестах
						+ 40 // 40 - хидер в выпадающем меню скачивания билдов
						+ 100 // 100 - верхний хидер и строка инструментов дашборда
						+ 55; // 55 нижняя часть с кнопкой DOWNLOAD для мультизагрузки

					let maxHeightByVH = (window.innerHeight - heightOffset) * 0.8; // берем 80% от доступной высоты

					height = Math.min(maxHeightByVH, maxHeightByNetworksCount);

				}

				// Меню второго уровня открывается на уровне родительского пункта, который может быть внизу экрана,
				// поэтому дополнительно ограничиваем его высоту так, чтобы оно не выходило за нижний край окна
				if (isInner) {

					let bottomMargin = 20; // отступ от нижнего края окна

					let maxHeightByScreenBottom = window.innerHeight - this.selectedGroupPosition.screenTop - bottomMargin;

					height = Math.min(height, Math.max(maxHeightByScreenBottom, 56)); // как минимум один пункт должен быть виден

				}

				return height;

			},
			getInnerHeight() {

				return this.getHeight(true);

			},
			getNetworkIcon(release) {
				let icon = release.options['icon'] || release.codename;
				if (icon.indexOf('.') === -1) icon += '.png';
				return icon;
			}
		}
	}
</script>

<style lang="sass">

	.networks
		position: relative
		overflow: visible !important

		.networks-content
			scrollbar-width: none
			-ms-overflow-style: none

		.networks-content::-webkit-scrollbar
			display: none

		.dropdown-item
			white-space: normal
			padding: 0px 20px 10px 20px
			width: 250px
			position: relative

			.group-expand-icon
				display: none
				position: absolute
				left: 6px
				top: 9px
				color: var(--gray)

			.multiple-select-checkmark-wrapper
				display: none

			.group-selected-releases-count
				display: none

			.item-title
				margin-bottom: 5px
				padding-top: 5px
				display: flex
				flex-direction: row
				align-items: center
				white-space: nowrap

				.icon
					margin-left: 10px

				.error
					font-size: 0.7rem
					margin-left: 5px
					color: #f86c6b

			.item-description
				white-space: normal
				line-height: 14px
				font-size: 12px
				width: 66%

			.item-icon
				position: absolute
				bottom: 5px
				right: 10px
				width: calc(37% - 10px)
				height: 44px
				opacity: 1
				background-size: contain
				background-repeat: no-repeat
				background-position: right center
				max-height: 55px
				font-size: 30px


		.dropdown-item.selected
			//border: 1px solid var(--green)

			.item-title
				color: var(--green)

			.multiple-select-checkmark-wrapper
				width: 30px
				display: flex
				justify-content: center

				.checkbox-background
					position: relative

					.fa.fa-check
						font-size: 13px

		.dropdown-item.outdated
			opacity: 0.3

		.dropdown-item.group

			.group-expand-icon
				display: flex

		.dropdown-item.selected.group

			.group-selected-releases-count
				display: flex
				font-size: 13px
				color: var(--green)

		.networks-inner
			// !important нужен, т.к. директива v-bar (vuebar) ставит инлайновый position: relative,
			// из-за чего меню второго уровня выпадало из абсолютного позиционирования и вставало в поток ниже списка
			position: absolute !important
			right: 300px
			width: 300px
			background-color: #3a4149
			background-clip: padding-box
			border: 1px solid #23282c
			box-shadow: 0 0 10px rgba(0, 0, 0, 0.5)
			margin-top: -1px
			border-radius: 3px

			.dropdown-item
				padding: 0px 10px 10px 10px

				.item-description
					width: 100%

				.item-icon
					display: none

	.networks::-webkit-scrollbar
		width: 10px
		margin-left: -10px
		-webkit-appearance: none
		appearance: none

	.networks::-webkit-scrollbar-track
		background-color: rgba(255,255,255,0.3)
		border-right: 1px solid #f2f2f2
		border-left: 1px solid #f2f2f2
		display: none

	.networks::-webkit-scrollbar-thumb
		height: 50px
		background-color: rgba(255,255,255,0.2)
		background-clip: content-box
		border-color: transparent
		border-style: solid
		border-width: 1px 2px

</style>

